"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.route = void 0;
var lodash_1 = require("lodash");
var fill = function (path, params) {
  return (0, lodash_1.trimEnd)((0, lodash_1.reduce)(params || {}, function (acc, value, key) {
    return acc.replace(new RegExp(":".concat(key), 'i'), (0, lodash_1.toString)(value));
  }, path).replace(/\*$/, params._trailing || ''), '/');
};
var route = function (path, params) {
  if (path === void 0) {
    path = '';
  }
  return params ? fill(path, params) : path;
};
exports.route = route;